import React from "react";
import LayoutMain from "../../components/Layout/Main/Main";
import LeftSidedImageCopyItemCollection from "../../Partials/LeftSidedImageCopyItem/collection";
import ProductMiniItemCollection from "../../Partials/ProductMiniItem/Collection";

const leftSidedImageCopyItemCollectionData = [
  {
    descriptionContent: (
      <>
        <p>
          <strong>
            Think Outside Gardens trusted and personalised service is delivered
            through consistency and a thorough knowledge of the product. Our
            team of skilled and experienced landscapers and horticulturalists
            work closely with the contractors we have developed relationships
            with over many years.
          </strong>
        </p>

        <p>
          In addition to meeting relevant Australian building standards and
          statutory requirements Think Outside Gardens strives for principles of
          best practice through industry associations. Think Outside Gardens
          construction service is offered in conjunction with or independently
          of the design service.
        </p>
        <p>
          <ul>
            <li>Timber decking and bench seating</li>
            <li>Retaining walls built in BBQ’s and outdoor kitchens</li>
            <li>Pool and spa management</li>
            <li>Roof top terraces</li>
            <li>Gates and fencing</li>
            <li>Outdoor structures cabanas or pergolas</li>
            <li>Difficult access work including cranes</li>
            <li>Water features</li>
            <li>Paving and Tiling</li>
            <li>Driveways</li>
            <li>Planting and associated horticultural works</li>
            <li>Irrigation systems / water tanks</li>
            <li>Garden lighting and outdoor electrical requirements</li>
          </ul>
        </p>
      </>
    ),
    image : 'images/about1.jpg',
    title : 'Construction'
  },
];
const ProductMiniItemCollectionData = [
  {
    image : 'images/contemporary-garden-oasis.jpg',
    title : 'Consultation',
    url : '/consultation'
  },
  {
    image : 'images/contemporary-garden-oasis-4.jpg',
    title : 'Design',
    url : '/design'
  },
  {
    image : 'images/contemporary-garden-oasis.jpg',
    title : 'Estimating',
    url : '/estimating'
  },
  {
    image : 'images/contemporary-garden-oasis-3.jpg',
    title : 'Maintenance',
    url : '/maintenance'
  },
]

const PageConstruction = () => {
  return <LayoutMain>
    <section className="about-top">
        <div className="container-3">
          <LeftSidedImageCopyItemCollection data={leftSidedImageCopyItemCollectionData} />
        </div>
</section>
 <section className=" pt-70 pb-120 pt-sm-30 pb-sm-40">
        <div className="container-3">
            <div className="row">
            <ProductMiniItemCollection data={ProductMiniItemCollectionData} />
            </div>
            </div>
            </section>
  </LayoutMain>;
};

export default PageConstruction;
